import { Button, Image } from "@chakra-ui/react"
import { Link } from "gatsby"
import React from "react"
import { Logo } from "../logo"
import "./styles.css"
import { OursLines } from "../../mocks/oursLine"
import { productCategories } from "../../mocks/productCategories"
import { normalizeString } from "../../utils/normalizeString"

export const Footer = () => {
  
  return (
    <footer
      id="footerVC"
      style={{
        background: "#F2F4F3",
      }}
    >
      <div className="container-xl">
        <div className="footer--items justify-content-between">
          <div className="col-12 col-md-6 col-xl-2">
            <div className="d-flex flex-column p-4 justify-content-center align-items-center my-4">
              <Logo />
              <svg
                width="100%"
                height="3"
                viewBox="0 0 288 3"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  y="0.786621"
                  width="100%"
                  height="2"
                  fill="#00615C"
                  fillOpacity="0.5"
                />
              </svg>

              <div className="my-3">
                <Button
                  as="a"
                  borderRadius="12.5rem"
                  colorScheme="green"
                  color="#025F1D"
                  variant="outline"
                  width={{ base: "14rem", md: "16rem", lg: "100%" }}
                  _hover={{
                    background: "#84ab8fa1",
                    color: "#fff !important",
                  }}
                  href="https://verdecampo.vagas.solides.com.br/"
                  target="_blank"
                >
                  Trabalhe Conosco
                </Button>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-4 col-xl-3">
            <div className="d-flex flex-column my-3 px-2">
              <span className="title--footer">Institucional</span>
              <a href="/nossa-historia" className="item--footer">
                Nossa história
              </a>
              <a href="/receitas" className="item--footer">
                Receitas
              </a>
              <a
                href="https://admin.verdecampo.com.br/wp-content/uploads/2024/10/Politica-Qse-Edição-facilitada-003.pdf"
                className="item--footer"
              >
                Política QSE
              </a>
              <a
                href="/divulgacao-do-relatorio-de-transparencia-salarial/"
                className="item--footer"
              >
                Relatório de Transparência Salarial
              </a>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-4 col-xl-2">
            <div className="d-flex flex-column my-3 px-2">
              <span className="title--footer">Fale conosco</span>
              <Link to="/faq" className="item--footer">
                Formulário de contato
              </Link>
              <a className="item--footer" href="tel:3538293000">
                (35) 3829 - 3000
              </a>
              <a className="item--footer" href="tel:08000310426">
                0800 031 0426
              </a>
              <a className="item--footer" href="mailto:sac@verdecampo.com.br">
                sac@verdecampo.com.br
              </a>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4 col-xl-2">
            <div className="d-flex flex-column my-3 px-2">
              <span className="title--footer">Produtos</span>
              <div className="d-flex flex-row">
                <ul className="nav flex-column">
                  {OursLines.map((item) => (
                    <li className="nav-item mb-1" key={`linha-${item.path}`}>
                      <a
                        className="item--footer"
                        href={`/nossas-linhas/${item.path}`}>
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
                <ul className="nav flex-column ms-4">
                  {productCategories.map((item) => (
                    <li className="nav-item mb-1" key={`category-${item.value}`}>
                      <a
                        className="item--footer"
                        href={`/produtos/${normalizeString(item.name.toLowerCase())}`}>
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4 col-xl-3">
            <div className="d-flex flex-column my-3 px-2">
              <span className="title--footer">Imprensa</span>
              <a
                className="item--footer"
                href="mailto:richard.novaes@redecomunicacao.com "

              >
                richard.novaes@redecomunicacao.com
              </a>


              <Image
                src="https://admin.verdecampo.com.br/wp-content/uploads/2024/02/eureciclo.png"
                alt="Product Image"
                borderRadius="1rem"
                objectFit="contain"
                width="90px"
                height="90px"
                style={{ marginTop: 20 }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="divider my-2"></div>
      <div className="container">
        <div className="row d-flex flex-row align-items-center flex-wrap-reverse justify-content-md-around justify-content-center py-3">
          <div className="col-md-6 col-12">
            <div className="d-flex flex-row justify-content-md-start justify-content-center ">
              <span className="copyright--footer my-3">
                © 2024 Verde Campo | Todos os direitos reservados
              </span>
            </div>
          </div>
          <div className="col-md-6 col-12">
            <div className="d-flex flex-row align-items-center justify-content-md-end justify-content-center social--footer">
              <span className="copyright--footer">
                <strong className="mb-0">Nos acompanhe:</strong>
              </span>

              <a href="https://www.facebook.com/VerdeCampoLat/" target="_blank">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.5 3H16.504C18.987 3 21 5.013 21 7.496V16.505C21 18.987 18.987 21 16.504 21H7.496C5.013 21 3 18.987 3 16.504V7.5C3 5.015 5.015 3 7.5 3V3Z"
                    stroke="#00615C"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.0996 12.8999H16.4996"
                    stroke="#00615C"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16.5004 8.3999H15.5554C14.0894 8.3999 12.9004 9.5889 12.9004 11.0549V11.9999V20.9999"
                    stroke="#00615C"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>

              <a
                href="https://www.instagram.com/verdecampo/?hl=en"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.496 3H16.505C18.987 3 21 5.012 21 7.496V16.505C21 18.987 18.988 21 16.504 21H7.496C5.013 21 3 18.988 3 16.504V7.496C3 5.013 5.012 3 7.496 3V3Z"
                    stroke="#00615C"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16.9487 6.71304C16.7627 6.71404 16.6117 6.86504 16.6117 7.05104C16.6117 7.23704 16.7637 7.38804 16.9497 7.38804C17.1357 7.38804 17.2867 7.23704 17.2867 7.05104C17.2877 6.86404 17.1357 6.71304 16.9487 6.71304"
                    stroke="#00615C"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.546 9.45432C15.9519 10.8602 15.9519 13.1396 14.546 14.5455C13.1401 15.9514 10.8607 15.9514 9.45481 14.5455C8.04892 13.1396 8.04892 10.8602 9.45481 9.45432C10.8607 8.04843 13.1401 8.04843 14.546 9.45432"
                    stroke="#00615C"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>

              <a
                href="https://www.youtube.com/channel/UCtMLPcsIDuuWualxo-DfM6A"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.583 6.37312C21.354 5.36912 20.676 4.57712 19.814 4.30512C18.255 3.81812 12 3.81812 12 3.81812C12 3.81812 5.748 3.81812 4.186 4.30512C3.327 4.57312 2.649 5.36512 2.417 6.37312C2 8.19512 2 12.0001 2 12.0001C2 12.0001 2 15.8051 2.417 17.6271C2.646 18.6311 3.324 19.4231 4.186 19.6951C5.748 20.1821 12 20.1821 12 20.1821C12 20.1821 18.255 20.1821 19.814 19.6951C20.673 19.4271 21.351 18.6351 21.583 17.6271C22 15.8051 22 12.0001 22 12.0001C22 12.0001 22 8.19512 21.583 6.37312Z"
                    stroke="#00615C"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.002 15L15.198 12L10.002 9V15Z"
                    stroke="#00615C"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>

              <a
                href="https://twitter.com/verdecampo_br?lang=en"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M19.95 9.3501C19.95 8.93588 19.6142 8.6001 19.2 8.6001C18.7858 8.6001 18.45 8.93588 18.45 9.3501H19.95ZM3.60565 16.1077C3.36134 15.7732 2.89213 15.7001 2.55764 15.9444C2.22314 16.1888 2.15004 16.658 2.39435 16.9925L3.60565 16.1077ZM2.87257 15.811C2.46438 15.8814 2.19053 16.2693 2.2609 16.6775C2.33128 17.0857 2.71924 17.3596 3.12743 17.2892L2.87257 15.811ZM5.7 15.6501L5.93829 16.3612C6.18386 16.2789 6.36961 16.0758 6.4296 15.8238C6.4896 15.5719 6.41535 15.3068 6.23322 15.1227L5.7 15.6501ZM4.8 4.8501L5.46058 4.49494C5.33797 4.26688 5.10639 4.1182 4.84798 4.10163C4.58958 4.08507 4.34091 4.20296 4.19018 4.4135L4.8 4.8501ZM10.2 9.3501L10.0229 10.0789C10.2422 10.1322 10.4739 10.0839 10.6537 9.94732C10.8334 9.81076 10.9421 9.60051 10.9496 9.37489L10.2 9.3501ZM18.3 6.6501L17.6738 7.06287C17.8126 7.27339 18.0479 7.4001 18.3 7.4001V6.6501ZM21 6.6501L21.624 7.06612C21.7775 6.83598 21.7918 6.54007 21.6613 6.2962C21.5307 6.05234 21.2766 5.9001 21 5.9001V6.6501ZM18.576 8.93407C18.3462 9.27872 18.4393 9.74437 18.784 9.97414C19.1286 10.2039 19.5943 10.1108 19.824 9.76612L18.576 8.93407ZM18.45 9.3501C18.45 12.3621 17.5901 14.8711 16.0501 16.6164C14.5204 18.35 12.2593 19.4001 9.3 19.4001V20.9001C12.6407 20.9001 15.3296 19.7002 17.1749 17.6088C19.0099 15.5291 19.95 12.6381 19.95 9.3501H18.45ZM9.3 19.4001C7.64458 19.4001 6.5374 18.9725 5.70459 18.3832C4.84887 17.7777 4.23772 16.9731 3.60565 16.1077L2.39435 16.9925C3.01928 17.8481 3.75813 18.8435 4.83816 19.6077C5.9411 20.3881 7.35542 20.9001 9.3 20.9001V19.4001ZM3.12743 17.2892C3.15119 17.2851 3.16958 17.2807 3.17593 17.2792C3.18458 17.2771 3.19158 17.2753 3.19578 17.2741C3.20418 17.2719 3.21102 17.2699 3.21457 17.2688C3.22212 17.2666 3.229 17.2645 3.23345 17.2631C3.24301 17.2601 3.25419 17.2566 3.26552 17.2529C3.28875 17.2454 3.32054 17.235 3.35881 17.2224C3.43573 17.1971 3.54331 17.1614 3.67073 17.1191C3.92579 17.0343 4.26283 16.9218 4.5986 16.8095C4.93446 16.6973 5.26937 16.5852 5.5203 16.5012C5.64577 16.4592 5.75026 16.4242 5.82338 16.3997C5.85994 16.3875 5.88866 16.3779 5.90825 16.3713C5.91804 16.368 5.92555 16.3655 5.93061 16.3638C5.93314 16.363 5.93506 16.3623 5.93634 16.3619C5.93699 16.3617 5.93747 16.3615 5.9378 16.3614C5.93796 16.3613 5.93808 16.3613 5.93816 16.3613C5.93821 16.3613 5.93824 16.3613 5.93826 16.3612C5.93828 16.3612 5.93829 16.3612 5.7 15.6501C5.46171 14.939 5.4617 14.939 5.46168 14.939C5.46166 14.939 5.46163 14.939 5.46159 14.939C5.46151 14.939 5.46139 14.9391 5.46123 14.9391C5.46091 14.9392 5.46042 14.9394 5.45978 14.9396C5.4585 14.94 5.45659 14.9407 5.45407 14.9415C5.44902 14.9432 5.44152 14.9457 5.43175 14.949C5.41219 14.9556 5.3835 14.9652 5.34697 14.9774C5.2739 15.0019 5.16949 15.0368 5.0441 15.0788C4.79331 15.1628 4.45867 15.2748 4.12315 15.3869C3.78755 15.4991 3.4514 15.6112 3.19749 15.6957C3.07042 15.7379 2.96458 15.773 2.88987 15.7976C2.85233 15.8099 2.82377 15.8193 2.80469 15.8254C2.79486 15.8286 2.78939 15.8303 2.78715 15.831C2.78569 15.8315 2.78787 15.8308 2.79198 15.8296C2.79381 15.8291 2.79923 15.8275 2.80654 15.8255C2.8102 15.8245 2.81673 15.8228 2.82499 15.8208C2.83095 15.8194 2.84904 15.8151 2.87257 15.811L3.12743 17.2892ZM6.23322 15.1227C3.48941 12.3487 3.28417 8.25569 5.40982 5.2867L4.19018 4.4135C1.64783 7.96451 1.89859 12.8735 5.16678 16.1775L6.23322 15.1227ZM4.13942 5.20525C5.31949 7.40017 7.53919 9.47526 10.0229 10.0789L10.3771 8.62131C8.40881 8.14294 6.49451 6.41803 5.46058 4.49494L4.13942 5.20525ZM10.9496 9.37489C10.9872 8.2389 11.388 7.29977 12.0242 6.64966C12.6563 6.00364 13.5621 5.6001 14.7 5.6001V4.1001C13.1869 4.1001 11.8857 4.64655 10.9521 5.60054C10.0225 6.55042 9.49883 7.86129 9.45041 9.3253L10.9496 9.37489ZM14.7 5.6001C15.5057 5.6001 16.0959 5.75301 16.5489 5.99477C17.0003 6.23567 17.3617 6.58945 17.6738 7.06287L18.9262 6.23733C18.5053 5.59874 17.9692 5.05253 17.2551 4.67143C16.5426 4.29119 15.6993 4.1001 14.7 4.1001V5.6001ZM18.3 7.4001H21V5.9001H18.3V7.4001ZM20.376 6.23407L18.576 8.93407L19.824 9.76612L21.624 7.06612L20.376 6.23407Z"
                    fill="#00615C"
                  />
                </svg>
              </a>

              <a
                href="https://br.linkedin.com/company/laticinio-verde-campo"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.5 3H16.504C18.987 3 21 5.013 21 7.496V16.505C21 18.987 18.987 21 16.504 21H7.496C5.013 21 3 18.987 3 16.504V7.5C3 5.015 5.015 3 7.5 3V3Z"
                    stroke="#00615C"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8.12012 11.1001V16.5001"
                    stroke="#00615C"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.7188 16.5001V13.3501C11.7188 12.1071 12.7257 11.1001 13.9688 11.1001V11.1001C15.2118 11.1001 16.2188 12.1071 16.2188 13.3501V16.5001"
                    stroke="#00615C"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8.11814 7.83799C7.99414 7.83799 7.89314 7.93899 7.89414 8.06299C7.89414 8.18699 7.99514 8.28799 8.11914 8.28799C8.24314 8.28799 8.34414 8.18699 8.34414 8.06299C8.34414 7.93799 8.24314 7.83799 8.11814 7.83799"
                    stroke="#00615C"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>

              <a
                href="https://www.tiktok.com/@verdecampo_"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <rect
                    x="3"
                    y="3"
                    width="18"
                    height="18"
                    rx="5"
                    stroke="#00615C"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10.5 11.5H10.2549C9.01135 11.4996 8.00236 12.5064 8 13.75H8C8 15.2688 9.23122 16.5 10.75 16.5V16.5C12.2688 16.5 13.5 15.2688 13.5 13.75V7.5"
                    stroke="#00615C"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M13.5 7.5C13.5 8.88071 14.6193 10 16 10"
                    stroke="#00615C"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}